import {
  SIGNED_WAIVER_SUCCEEDED,
  VALUES_SUBMITTED,
  SIGNED_WAIVER_FAILED,
  SIGNED_WAIVER_SUBMIT_STARTED,
  LOCATION_RETRIEVED,
  PATH_REFERENCE_RETRIEVED,
  PATH_PARTICIPANTS_RETRIEVED,
  LINKED_PARTICIPANT,
  LINKED_PARTICIPANTS,
  UPDATE_PPS,
  SELECTED_NAMES,
  ON_SELECT,
  PPS_SELECTED,
  PARTICIPANT_REMOVED,
  PATH_PARTICIPANTS_RESET, PATH, GUID_SET
} from "../constants";
import { compose, concat, filter, isNil, merge, pluck } from "ramda";

const initSW = {
  data: {},
  submitting: false,
  failed: false,
  succeeded: false,
  guid: null
};

export const signedWaiver = (state = initSW, action) => {
  switch (action.type) {
    case VALUES_SUBMITTED:
      return Object.assign({}, state, { data: action.payload });
    case SIGNED_WAIVER_SUCCEEDED:
      return Object.assign({}, state, {
        submitting: false,
        failed: false,
        succeeded: true,
      });
    case SIGNED_WAIVER_FAILED:
      return {
        ...state,
        failed: true,
        submitting: false,
        succeeded: false,

      };
    case SIGNED_WAIVER_SUBMIT_STARTED:
      return Object.assign({}, state, {
        submitting: true,
        failed: false,
        succeeded: false
      });
    case GUID_SET:
      return Object.assign({}, state, { guid: action.payload })
    default:
      return state;
  }
};

const initialPathParticipantsState = {
  participants: [],
  updatedParticipants: [],
  linkedParticipants: [],
  selectedParticipants: [],
  linkedParticipant: {},
  selectedNames: [],
  linkedPath: false
};

export const pathParticipants = (
  state = initialPathParticipantsState,
  action
) => {
  switch (action.type) {
    case PATH_PARTICIPANTS_RETRIEVED:
      return {
        ...state,
        linkedPath: action.payload.linkedPath,
        participants: action.payload.participants
      };

    case PATH_PARTICIPANTS_RESET:
      return merge(state, initialPathParticipantsState);

    case LINKED_PARTICIPANT:
      const linkedParticipantObj = filter(
        linkedParticipant =>
          linkedParticipant.participantId === Number(action.payload),
        state.participants
      );
      return merge(state, { linkedParticipant: linkedParticipantObj });

    case LINKED_PARTICIPANTS:
      const linkedParticipantsObj = filter(
        linkedParticipants =>
          linkedParticipants.participantId === Number(action.payload),
        state.participants
      );
      if (isNil(state.linkedParticipants)) {
        return merge(state, { linkedParticipants: linkedParticipantsObj });
      } else {
        return {
          ...state,
          linkedParticipants: concat(
            state.linkedParticipants,
            linkedParticipantsObj
          )
        };
      }

    case UPDATE_PPS:
      return { ...state, updatedParticipants: action.payload };
    case PPS_SELECTED:
      return {
        ...state,
        selectedParticipants: concat(action.payload, state.selectedParticipants)
      };

    case PARTICIPANT_REMOVED:
      return {
        ...state,
        selectedParticipants: action.payload.selectedParticipants,
        selectedNames: action.payload.selectedNames
      };

    case SELECTED_NAMES:
      const selectedPersonsName = compose(
        pluck("participantName"),
        filter(p => p.participantId === action.payload.participantId)
      )(state.participants);

      return {
        ...state,
        selectedNames: concat(state.selectedNames, selectedPersonsName)
      };
    case ON_SELECT:
      return {
        ...state,
        referenceKey: action.payload.referenceKey,
        participantsName: action.payload.participantName
      };
    default:
      return state;
  }
};
export const locationData = (state = {}, action) => {
  switch (action.type) {
    case LOCATION_RETRIEVED:
      return { ...state, lat: action.payload.lat, lon: action.payload.lon };
    case PATH_REFERENCE_RETRIEVED:
      return { ...state, referenceKey: action.payload.referenceKey };
    default:
      return state;
  }
};
export const pathInfo = (state = {}, action) => {
  switch (action.type) {
    case PATH:
      return Object.assign({}, state, { waiverId: action.payload.waiverId, refLocation: action.payload.refLocation, remainingPath: action.payload.remainingPath })
    default:
      return state
  }
}